import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationTypePipe } from './location-type.pipe';
@NgModule({
  declarations: [LocationTypePipe],
  imports: [CommonModule],
  exports: [LocationTypePipe],
})
export class LocationTypePipeModule {}
